import {
  Box,
  Button,
  Center,
  Grid,
  GridItem,
  HStack,
  Text,
} from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import Icon from "@modules/Icon";
import MediaModal from "@modules/Layout/components/MediaModal";
import { NeedHelpIconHero } from "@modules/Layout/style";
import React from "react";
import { If, Then } from "react-if";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import useDownloadPdf from "../hooks/useDownloadPdf";
import useMediaModal from "../hooks/useMediaModal";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { OverViewTab } from "../styles";

const Overview = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const {
    overview,
    resources: { data: resourceCategories },
  } = result!.data.attributes;

  const { isOpen, handleOpenModal, handleCloseModal } = useMediaModal();

  const onDownloadPdf = useDownloadPdf();

  const handleDownloadPdf = (item: any) => {
    const fileURL = item?.download_file?.data?.attributes?.url;
    const fileName = item?.download_file?.data?.attributes?.name;

    if (fileURL && fileName) {
      onDownloadPdf(fileURL, fileName);
    }
  };

  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={4}>
      <GridItem
        colSpan={{ base: 3, md: 2 }}
        pr={{ base: 0, md: 10, lg: 20, xl: 40 }}
      >
        <OverViewTab>
          <ReactMarkdown children={overview.content} />
        </OverViewTab>
      </GridItem>
      <GridItem colSpan={{ base: 3, md: 1 }}>
        <Box px={{ base: 1, lg: 7 }} py={7} bg={"white50"}>
          {resourceCategories.map((resourceItem, index) => {
            const item = resourceItem.attributes;
            return (
              <HStack key={index}>
                <If condition={item.type === "download"}>
                  <Then>
                    <Button
                      borderWidth={0}
                      borderColor={"transparent"}
                      onClick={() => handleDownloadPdf(item)}
                      mb={4}
                    >
                      <Center
                        bg={"blue500"}
                        width={"2.8125rem"}
                        height={"2.8125rem"}
                        borderRadius={"50%"}
                      >
                        <NeedHelpIconHero>
                          <Icon name={"downloadBrochure"} />
                        </NeedHelpIconHero>
                      </Center>
                      <Text
                        noOfLines={1}
                        color={"blue500"}
                        ml={5}
                        lineHeight={"1rem"}
                      >
                        <Box
                          as="span"
                          display={{ base: "none", md: "inline-block" }}
                        >
                          Download
                        </Box>{" "}
                        {item.name}
                      </Text>
                    </Button>
                  </Then>
                </If>

                <If condition={item.type === "installation"}>
                  <Then>
                    <Button
                      onClick={handleOpenModal}
                      mb={4}
                      borderWidth={0}
                      borderColor={"transparent"}
                    >
                      <Center
                        bg={"blue500"}
                        width={"2.8125rem"}
                        height={"2.8125rem"}
                        borderRadius={"50%"}
                      >
                        <NeedHelpIconHero>
                          <Icon name={"viewInstallation"} />
                        </NeedHelpIconHero>
                      </Center>
                      <Text
                        color={"blue500"}
                        ml={5}
                        lineHeight={"1rem"}
                        noOfLines={1}
                      >
                        {item.name}
                      </Text>
                    </Button>
                    <MediaModal
                      type="image"
                      url={item?.thumbnail?.data?.attributes?.url}
                      isOpen={isOpen}
                      handleCloseModal={handleCloseModal}
                    />
                  </Then>
                </If>
              </HStack>
            );
          })}

          <Button as={GatsbyLink} to="/schedule-a-demo/" variant="primary">
            Schedule a Demo
          </Button>

          <HStack mt={4}>
            <GatsbyLink to={"/support/"}>
              <Button borderWidth={0} borderColor={"transparent"}>
                <Center
                  bg={"blue500"}
                  width={"2.8125rem"}
                  height={"2.8125rem"}
                  borderRadius={"50%"}
                >
                  <NeedHelpIconHero>
                    <Icon name={"tool"} />
                  </NeedHelpIconHero>
                </Center>
                <Text color={"blue500"} ml={5} lineHeight={"1rem"}>
                  Support
                </Text>
              </Button>
            </GatsbyLink>
          </HStack>
        </Box>
      </GridItem>
    </Grid>
  );
};
export default Overview;
